module.exports = __webpack_public_path__ + "img/file-search.4e0964e.svg";